import _get from 'lodash/get';
import { removeValueFromLocalStorage } from './localStorage';
import TEnvReader from '../readers/Env';
export var getRecentlyUsedStorageKey = function getRecentlyUsedStorageKey() {
  return "recentlyUsedPageList_".concat(_get(TEnvReader.userInfo(), 'id'));
};
export var clearRecentlyUsedAppStorage = function clearRecentlyUsedAppStorage() {
  removeValueFromLocalStorage(getRecentlyUsedStorageKey());
};